import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to #id when the route includes a hash (e.g. footer links to /#faq).
 */
export default function HashScroll() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    if (!id) return;

    const run = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const t = window.setTimeout(run, 0);
    return () => window.clearTimeout(t);
  }, [pathname, hash, key]);

  return null;
}
